<template>
  <div class="cms-video-player" v-if="mediaSource">
    <video controls style="width: 100%">
      <source
        style="width: 100%; max-height: calc(100vh - 50px - 50px)"
        type="video/mp4"
        :src="mediaSource"
      />
    </video>
  </div>
</template>

<script setup lang="ts">
import { debug as d } from "debug";
import { onMounted } from "vue";

const debug = d("cs.CmsVideoPlayerComponent");

const props = defineProps<{
  mediaSource: string | undefined;
}>();

onMounted(() => {
  debug("Displaying video player", props.mediaSource);
});
</script>
